var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"out-back-demo"},[_vm._l((_vm.CustomList),function(item,index){return _c('div',{key:index},[_c('Custom',{attrs:{"CustomList":item,"type":"canceled"},on:{"customMusic":_vm.customMusic}})],1)}),_c('CustomPopup',{ref:"customPopup",attrs:{"customMusic":_vm.customMusicData}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }